import { createSupabaseClient, type ExcelCenterSupabaseClient } from "@excel-center/supabase";
import { env } from "@/src/common/constants/env";

/**
 * Shared, typed Supabase client for the web app.
 * Call the Supabase SDK directly from components / RTK Query endpoints /
 * services — no API layer sits between the browser and Supabase in V1
 * (RLS is the primary authorization boundary).
 */
export const supabase: ExcelCenterSupabaseClient = createSupabaseClient({
	url: env.SUPABASE_URL,
	key: env.SUPABASE_ANON_KEY,
	storageKey: `${env.APP_SLUG}.auth`,
});
